"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDirection = function (column, columnReverse, rowReverse) {
    if (column) {
        return 'column';
    }
    if (columnReverse) {
        return 'column-reverse';
    }
    if (rowReverse) {
        return 'row-reverse';
    }
    return 'row';
};
exports.default = (function (_a) {
    var column = _a.column, columnReverse = _a.columnReverse, rowReverse = _a.rowReverse;
    var direction = getDirection(column, columnReverse, rowReverse);
    return "flex-direction: " + direction + ";";
});
